import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  useMediaQuery,
  useTheme,
  IconButton,
} from "@mui/material";
import authApi from "../../services/auth";
import { useDispatch } from "react-redux";
import { showLoader, hideLoader } from "../../redux/loader/actions";
import { showSnackbar } from "../../redux/snackbar/actions";
import CloseIcon from "@mui/icons-material/Close";

const RememberDialog = ({
  open,
  onClose,
  message,
  onResend,
  rememberUUID,
  setRemember,
  setRememberMsg,
  setRememberUUID,
}) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const resendLink = () => {
    dispatch(showLoader())
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        dispatch(
          showSnackbar({
            message: res?.data?.msg,
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "success",
          })
        );
        onClose();
        setRemember();
        setRememberMsg();
        setRememberUUID();
      }
    };
    const onFailure = (err) => {
      console.log(err, "error");
      dispatch(hideLoader());
      if (!err?.response?.data?.regenerate) {
        dispatch(
          showSnackbar({
            message: err?.response?.data?.msg,
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "error",
          })
        );
      }
    };
    authApi.resend24(rememberUUID).then(onSuccess, onFailure);
  };

  return (
    <Dialog
    fullScreen={fullScreen}
    open={open}
    aria-labelledby="remember-dialog-title"
  >
    <DialogTitle id="remember-dialog-title">
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
    </DialogTitle>
    <DialogContent>
      <Typography variant="body1">{message}</Typography>
    </DialogContent>
    <DialogActions>
      <Button onClick={resendLink} color="error" variant="contained" autoFocus>
        Resend Link
      </Button>
    </DialogActions>
  </Dialog>
  );
};
export default RememberDialog;
